import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GeneratePostFileSignedUrls.graphql';
import { Query, QuerygeneratePostFileSignedUrlsArgs } from '../../__generated__/globalTypes';

export const useGeneratePostFileSignedUrlsQuery = (
  options?: QueryHookOptions<Query, QuerygeneratePostFileSignedUrlsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygeneratePostFileSignedUrlsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGeneratePostFileSignedUrlsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygeneratePostFileSignedUrlsArgs>
): QueryResult<Query, QuerygeneratePostFileSignedUrlsArgs> & {
  getGeneratePostFileSignedUrls: LazyQueryExecFunction<Query, QuerygeneratePostFileSignedUrlsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGeneratePostFileSignedUrls, result] = useLazyQuery<Query, QuerygeneratePostFileSignedUrlsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGeneratePostFileSignedUrls, ...result };
};

export const useGeneratePostFileSignedUrlsPromiseQuery = () => {
  const client = useApolloClient();

  const getGeneratePostFileSignedUrls = useCallback(
    (options?: Omit<QueryOptions<QuerygeneratePostFileSignedUrlsArgs, Query>, 'query'>) =>
      client.query<Query, QuerygeneratePostFileSignedUrlsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGeneratePostFileSignedUrls };
};
// Suspense Query Hooks
export const useGeneratePostFileSignedUrlsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygeneratePostFileSignedUrlsArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygeneratePostFileSignedUrlsArgs>(QUERY, {
    ...options
  });

  return result;
};
